// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SettlementPortalTexts_root__iTB58 {
  border: 1px solid var(--color-theme-bright-gray);
}

.SettlementPortalTexts_language_header__fUHKk {
  background-color: var(--color-theme-white);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px;
  border-radius: 1px;
}

.SettlementPortalTexts_language_name_container__yKvLH {
  width: 18%;
  display: flex;
  justify-content: space-between;
}
.SettlementPortalTexts_language_title__W27aR {
  width: 50%;
}

.SettlementPortalTexts_btn_default__VB-o4 {
  width: 150px;
  font-weight: 600 !important;
  color: var(--color-theme-blue) !important;
  border: 1px solid var(--color-theme-blue) !important;
  height: 40px;
  margin-right: 20px !important;
}

.SettlementPortalTexts_btn_default__VB-o4:disabled {
  width: 150px;
  font-weight: 600 !important;
  color: var(--color-font-10) !important;
  background-color: var(--color-theme-silver) !important;
  height: 40px;
  margin-right: 20px !important;
}

.SettlementPortalTexts_btn_activate__xrcs6 {
  width: 150px;
  font-weight: 600 !important;
  color: var(--color-theme-blue) !important;
  border: 1px solid var(--color-theme-blue) !important;
  height: 40px;
}

.SettlementPortalTexts_btn_activate__xrcs6:disabled {
  width: 150px;
  font-weight: 600 !important;
  color: var(--color-font-10) !important;
  background-color: var(--color-theme-silver) !important;
  height: 40px;
}

.SettlementPortalTexts_btn_deactivate__LU2Cd {
  width: 150px;
  font-weight: 600 !important;
  color: var(--color-font-10) !important;
  border: 1px solid var(--color-theme-silver) !important;
  height: 40px;
}

.SettlementPortalTexts_btn_deactivate__LU2Cd:disabled {
  width: 150px;
  font-weight: 600 !important;
  color: var(--color-font-10) !important;
  background-color: var(--color-theme-silver) !important;
  height: 40px;
}

.SettlementPortalTexts_tabs_content_container__qXiaV {
  padding: 40px 30px 30px 30px;
  border-top: 1px solid var(--color-theme-gray);
}

.SettlementPortalTexts_label__hhT03 {
  padding: 0px;
  margin-bottom: 10px;
  font-size: 16px;
}

.SettlementPortalTexts_label__hhT03 b {
  font-size: 12px;
  color: var(--color-theme-red);
  padding-left: 5px;
}

.SettlementPortalTexts_confirm_btn_container__4Kwuy {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 30px 0px;
}

.SettlementPortalTexts_confirm_btn__FwnPA {
  color: var(--color-theme-blue) !important;
  border: 1px solid var(--color-theme-blue) !important;
  width: 174px;
  height: 41px;
  font-weight: bold !important;
}

.SettlementPortalTexts_confirm_btn_disabled__poqsh {
  color: var(--color-theme-10) !important;
  background-color: var(--color-theme-silver) !important;
  width: 174px;
  height: 41px;
  font-weight: bold !important;
  cursor: auto !important;
}

.SettlementPortalTexts_text_description__HDozH {
  font-size: 14px;
}

/* faq tab */
.SettlementPortalTexts_add_faq_btn_container__JlupV {
  display: flex;
  justify-content: flex-end;
  padding: 20px 0px;
}

.SettlementPortalTexts_add_faq_btn__1EG99 {
  border: 1px solid var(--color-theme-silver) !important;
  color: var(--color-theme-10) !important;
}

.SettlementPortalTexts_label_faq__FaAxh {
  padding-bottom: 10px;
  font-size: 16px;
}

.SettlementPortalTexts_faq_container__1WqdL {
  display: flex;
  border: 1px solid var(--color-theme-silver);
  align-items: top;
  padding: 10px;
  margin: 10px 0px;
}

.SettlementPortalTexts_faq_input_container__QYiUL {
  display: flex;
  flex-direction: column;
  padding: 10px;
  width: 100%;
}

.SettlementPortalTexts_delete_icon__2FFO\\+ {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/SettlementPortalTexts/SettlementPortalTexts.module.css"],"names":[],"mappings":"AAAA;EACE,gDAAgD;AAClD;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,yCAAyC;EACzC,oDAAoD;EACpD,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,sCAAsC;EACtC,sDAAsD;EACtD,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,yCAAyC;EACzC,oDAAoD;EACpD,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,sCAAsC;EACtC,sDAAsD;EACtD,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,sCAAsC;EACtC,sDAAsD;EACtD,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,sCAAsC;EACtC,sDAAsD;EACtD,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,oDAAoD;EACpD,YAAY;EACZ,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;EACvC,sDAAsD;EACtD,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,sDAAsD;EACtD,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".root {\n  border: 1px solid var(--color-theme-bright-gray);\n}\n\n.language_header {\n  background-color: var(--color-theme-white);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0px 20px;\n  border-radius: 1px;\n}\n\n.language_name_container {\n  width: 18%;\n  display: flex;\n  justify-content: space-between;\n}\n.language_title {\n  width: 50%;\n}\n\n.btn_default {\n  width: 150px;\n  font-weight: 600 !important;\n  color: var(--color-theme-blue) !important;\n  border: 1px solid var(--color-theme-blue) !important;\n  height: 40px;\n  margin-right: 20px !important;\n}\n\n.btn_default:disabled {\n  width: 150px;\n  font-weight: 600 !important;\n  color: var(--color-font-10) !important;\n  background-color: var(--color-theme-silver) !important;\n  height: 40px;\n  margin-right: 20px !important;\n}\n\n.btn_activate {\n  width: 150px;\n  font-weight: 600 !important;\n  color: var(--color-theme-blue) !important;\n  border: 1px solid var(--color-theme-blue) !important;\n  height: 40px;\n}\n\n.btn_activate:disabled {\n  width: 150px;\n  font-weight: 600 !important;\n  color: var(--color-font-10) !important;\n  background-color: var(--color-theme-silver) !important;\n  height: 40px;\n}\n\n.btn_deactivate {\n  width: 150px;\n  font-weight: 600 !important;\n  color: var(--color-font-10) !important;\n  border: 1px solid var(--color-theme-silver) !important;\n  height: 40px;\n}\n\n.btn_deactivate:disabled {\n  width: 150px;\n  font-weight: 600 !important;\n  color: var(--color-font-10) !important;\n  background-color: var(--color-theme-silver) !important;\n  height: 40px;\n}\n\n.tabs_content_container {\n  padding: 40px 30px 30px 30px;\n  border-top: 1px solid var(--color-theme-gray);\n}\n\n.label {\n  padding: 0px;\n  margin-bottom: 10px;\n  font-size: 16px;\n}\n\n.label b {\n  font-size: 12px;\n  color: var(--color-theme-red);\n  padding-left: 5px;\n}\n\n.confirm_btn_container {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 30px 0px;\n}\n\n.confirm_btn {\n  color: var(--color-theme-blue) !important;\n  border: 1px solid var(--color-theme-blue) !important;\n  width: 174px;\n  height: 41px;\n  font-weight: bold !important;\n}\n\n.confirm_btn_disabled {\n  color: var(--color-theme-10) !important;\n  background-color: var(--color-theme-silver) !important;\n  width: 174px;\n  height: 41px;\n  font-weight: bold !important;\n  cursor: auto !important;\n}\n\n.text_description {\n  font-size: 14px;\n}\n\n/* faq tab */\n.add_faq_btn_container {\n  display: flex;\n  justify-content: flex-end;\n  padding: 20px 0px;\n}\n\n.add_faq_btn {\n  border: 1px solid var(--color-theme-silver) !important;\n  color: var(--color-theme-10) !important;\n}\n\n.label_faq {\n  padding-bottom: 10px;\n  font-size: 16px;\n}\n\n.faq_container {\n  display: flex;\n  border: 1px solid var(--color-theme-silver);\n  align-items: top;\n  padding: 10px;\n  margin: 10px 0px;\n}\n\n.faq_input_container {\n  display: flex;\n  flex-direction: column;\n  padding: 10px;\n  width: 100%;\n}\n\n.delete_icon {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `SettlementPortalTexts_root__iTB58`,
	"language_header": `SettlementPortalTexts_language_header__fUHKk`,
	"language_name_container": `SettlementPortalTexts_language_name_container__yKvLH`,
	"language_title": `SettlementPortalTexts_language_title__W27aR`,
	"btn_default": `SettlementPortalTexts_btn_default__VB-o4`,
	"btn_activate": `SettlementPortalTexts_btn_activate__xrcs6`,
	"btn_deactivate": `SettlementPortalTexts_btn_deactivate__LU2Cd`,
	"tabs_content_container": `SettlementPortalTexts_tabs_content_container__qXiaV`,
	"label": `SettlementPortalTexts_label__hhT03`,
	"confirm_btn_container": `SettlementPortalTexts_confirm_btn_container__4Kwuy`,
	"confirm_btn": `SettlementPortalTexts_confirm_btn__FwnPA`,
	"confirm_btn_disabled": `SettlementPortalTexts_confirm_btn_disabled__poqsh`,
	"text_description": `SettlementPortalTexts_text_description__HDozH`,
	"add_faq_btn_container": `SettlementPortalTexts_add_faq_btn_container__JlupV`,
	"add_faq_btn": `SettlementPortalTexts_add_faq_btn__1EG99`,
	"label_faq": `SettlementPortalTexts_label_faq__FaAxh`,
	"faq_container": `SettlementPortalTexts_faq_container__1WqdL`,
	"faq_input_container": `SettlementPortalTexts_faq_input_container__QYiUL`,
	"delete_icon": `SettlementPortalTexts_delete_icon__2FFO+`
};
export default ___CSS_LOADER_EXPORT___;
